module.exports = __webpack_public_path__ + "static/media/EARLY_ACCESS_60X50.bf72ca63.svg";